import styles from "./Footer.module.css";

// react
import React from "react";

export default function Footer() {
	return (
		<footer className={styles.footer}>
			<a className={styles.a} target="_blank" rel="noopener noreferrer" href="https://www.private-radar.com/">
				<span>&nbsp;© Private-Radar 2014-2022 </span>
				<span> - Version: 1.0</span>
			</a>
		</footer>
	);
}
